var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('card',[_c('StopPunctualityReportTable')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }